const cardTypeOCR = {
  firstGeneration: 'ID nasional generasi pertama',
  frontSecondGeneration: 'Hadapan ID nasional generasi kedua',
  backSecondGeneration: 'Bahagian belakang identiti nasional generasi kedua',
  chinaTemporary: 'ID nasional sementara China',
  bankCard: 'Kad bank',
};

export default cardTypeOCR;
